// Google Class
const smartixRow1 = {
  single: {
    "twoItems": {
      "startItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_DATE__']"
            }
          ]
        }
      },
      "endItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_TIME__']"
            }
          ]
        }
      }
    }
  },
  multiple: {
    "threeItems": {
      "startItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_DATE__']"
            }
          ]
        }
      },
      "middleItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_TIME__']"
            }
          ]
        }
      },
      "endItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_TICKET_TYPE__']"
            }
          ]
        }
      }
    }
  }
}

const smartixRow2 = {
  seat:
  {
    "oneItem": {
      "item": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_SEAT__']"
            }
          ]
        }
      }
    }
  },
  row:
  {
    "twoItems": {
      "startItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_ROW__']"
            }
          ]
        }
      },
      "endItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_SEAT__']"
            }
          ]
        }
      }
    }
  },
  section:
  {
    "threeItems": {
      "startItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_SECTION__']"
            }
          ]
        }
      },
      "middleItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_ROW__']"
            }
          ]
        }
      },
      "endItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_SEAT__']"
            }
          ]
        }
      }
    }
  },
  gate:
  {
    "threeItems": {
      "startItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_GATE__']"
            }
          ]
        }
      },
      "middleItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_SECTION__']"
            }
          ]
        }
      },
      "endItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['__SMARTIX_ROW_AND_SEAT__']"
            }
          ]
        }
      }
    }
  }
}

const standardRow1 = {
  single: {
    "twoItems": {
      "startItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['DATE']"
            }
          ]
        }
      },
      "endItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['TIME']"
            }
          ]
        }
      }
    }
  },
  multiple: {
    "threeItems": {
      "startItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['DATE']"
            }
          ]
        }
      },
      "middleItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['TIME']"
            }
          ]
        }
      },
      "endItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['TICKET_TYPE']"
            }
          ]
        }
      }
    }
  }
}

const standardRow2 = {
  seat:
  {
    "oneItem": {
      "item": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['SEAT']"
            }
          ]
        }
      }
    }
  },
  row:
  {
    "twoItems": {
      "startItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['ROW']"
            }
          ]
        }
      },
      "endItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['SEAT']"
            }
          ]
        }
      }
    }
  },
  section:
  {
    "threeItems": {
      "startItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['SECTION']"
            }
          ]
        }
      },
      "middleItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['ROW']"
            }
          ]
        }
      },
      "endItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['SEAT']"
            }
          ]
        }
      }
    }
  },
  gate:
  {
    "threeItems": {
      "startItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['GATE']"
            }
          ]
        }
      },
      "middleItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['SECTION']"
            }
          ]
        }
      },
      "endItem": {
        "firstValue": {
          "fields": [
            {
              "fieldPath": "object.textModulesData['ROW_AND_SEAT']"
            }
          ]
        }
      }
    }
  }
}


const standard = {
  row1 : standardRow1,
  row2 : standardRow2
}

const smartix = {
  row1 : smartixRow1,
  row2 : smartixRow2
}

export default {
  standard,
  smartix
}